import L from 'src/lib/leaflet'

export default {
  engine: null,
  query: null,
  history: [],
  errorFetching: false,
  fetchingResults: null,
  finalResults: null,
  result: null,
  resultsLayer: L.featureGroup(),
  auto: true
}
